<template>
  <div class="py-0">
    <v-row align="center" justify="start">
      <v-col cols="12">
        <v-skeleton-loader
          v-if="filterconsolidado.length === 0 && filter.query === ''"
          type="text"
        ></v-skeleton-loader>

        <v-text-field
          v-else
          ref="search"
          loading
          v-model="buscar"
          full-width
          hide-details
          :label="`Buscar en ${nbcat}`"
          single-line
          prepend-inner-icon="mdi-magnify"
          outlined
          :solo-inverted="!$vuetify.breakpoint.mdAndUp"
        >
          <template v-slot:progress>
            <v-progress-linear
              :value="progress"
              :style="[progress < 3 ? 'color:blue' : 'color:red']"
              absolute
              height="7"
            ></v-progress-linear> </template
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "buscartxt",
  computed: {
    ...mapState(["filter"]),
    ...mapGetters(["filterconsolidado", "filterscat", "filtermarca"]),
    progress() {
      return Math.min(100, this.buscar.length * 11);
    },
    buscar: {
      get() {
        return this.filter.query;
      },
      set(val) {
        setInterval(this.GET_BUSCAR(val), 155000);
      },
    },
  },
  methods: {
    ...mapMutations(["GET_BUSCAR"]),
  },
  props: {
    nbcat: String,
  },
};
</script>

<style>
</style>